import React, { useState, useEffect } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import { Button, Avatar, Box, TextField, Icon, Chip } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import { fade, makeStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import {Search, Add, Refresh, ChevronLeftRounded, ChevronRightRounded} from '@material-ui/icons';
import * as RFIcon from 'react-feather'; 
import language from '../../languages';
import CSVReader from 'react-csv-reader';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  appBar: {
    boxShadow: 'none',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    color: '#09205C'
  },
  titleIcon: {
    color: '#09205C',
    marginRight: theme.spacing(2)
  },
  search: {
    flexGrow: 4,
    position: 'relative',
    borderRadius: 2,
    backgroundColor: fade('#372020', 0.15),
    '&:hover': {
      backgroundColor: fade('#372020', 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: '32%',
    },
    borderRadius: 10
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  clearIcon: {
    height: '100%',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    right: 0,
  },
  chipsArea: {
    height: '100%',
    display: 'inline',
    padding: theme.spacing(0, 2),
    // paddingRight: `calc(1em + ${theme.spacing(4)}px)`,
    // transition: theme.transitions.create('width'),
  },
  inputRoot: {
    color: 'inherit',
    marginLeft: theme.spacing(1),
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: theme.spacing(0, 1),
    // vertical padding + font size from searchIcon
    // paddingRight: `calc(1em + ${theme.spacing(4)}px)`,
    // transition: theme.transitions.create('width'),
    width: '100%',
    '&:focus': {
      backgroundColor: '#e0e0e0'
    },
    '&:hover': {
      backgroundColor: '#e0e0e0'
    },
    [theme.breakpoints.up('sm')]: {
      width: '100%',
      '&:focus': {
        width: '100%',
      },
    },
  },
  filterShow: {
      backgroundColor: '#3076CA',
      cursor: 'pointer'
  },
  filterHide: {
      backgroundColor: '#ffffff',
      cursor: 'pointer'
  },
  actionArea: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    color: '#09205C'
  },
  addButton: {
    color: '#ffffff',
    backgroundColor: '#3076CA',
    '&:hover': {
      backgroundColor: fade('#3076CA', 0.75),
    },
    margin: '8px 0;',
    textTransform: 'capitalize'
  }
}));

export default function BaseToolbar(props) {
  const classes = useStyles();
  const { readOnly, showFilterToggle, showFilterOption, isFilter, addButtonText, onlyForm, 
      hideTitle, hideAddButton, settingsFields, filterObj, handleFilter, searchTerms, 
      lang, uploadFromCsv, isUploadCsv, getTitle } = props;
  const [searchTerm, setSearchTerm] = useState('')

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && searchTerm.length > 0) {
      props.onSearch(searchTerm)
      setSearchTerm('')
    }
  }

  return (
      <AppBar color="transparent" position="static" className={classes.appBar}>
        <Toolbar>
          <Icon className={classes.titleIcon}>
            { !hideTitle && props.headerIcon }
          </Icon>
          <Typography className={classes.title} variant="h6" noWrap>
             { !hideTitle ? props.title : getTitle }
          </Typography>
          { showFilterOption &&
          <Tooltip title={isFilter ? language[lang].Hide_Filters : language[lang].Show_Filters}  arrow>
            <Avatar className={isFilter ? classes.filterShow : classes.filterHide} onClick={() => showFilterToggle(!isFilter)}>
              <RFIcon.Filter color={isFilter ? '#ffffff' : '#2735A4'} strokeWidth={2} />
            </Avatar>
          </Tooltip>
          }
          {!settingsFields && <>
          <div className={classes.search} style={onlyForm ? {visibility: 'hidden'} : {}}>
            {/* <div className={classes.searchIcon}>
              <RFIcon.Search strokeWidth={1} />
            </div> */}
            <div className={classes.clearIcon}>
              <Tooltip title={language[lang].Clear_all_filters} arrow>
                <IconButton style={{padding: 8}} size='small' component="span" onClick={props.resetFilter} >
                  <RFIcon.X strokeWidth={2} />
                </IconButton>
              </Tooltip>
            </div>
            <div style={{padding: '4px 0px', paddingRight: 36}}>
            <div className={classes.chipsArea}>
              {
                filterObj.map((filters, i) => {
                  return <React.Fragment key = {i}>
                    {filters.items.map((filter, j) => {
                      let e = {}
                      e.target = {
                        name: filters.name,
                        value: filter.value,
                        checked: false
                      }
                    return filter.selected && <Chip key={j} label={filter.label} onDelete={() => {handleFilter(e)}} />
                    })}
                  </React.Fragment>
                })
              }
              {
                searchTerms.map((value, i) => {
                  return <Chip key={i} label={value} onDelete={() => {props.deleteSearchTerms(value)}} />
                })
              }
              {/* <Tooltip title='Clear all filters'  arrow>
                <IconButton style={{float: 'right', padding: 8}} size='small' component="span" onClick={props.resetFilter} >
                  <RFIcon.X strokeWidth={2} />
                </IconButton>
              </Tooltip> */}
            </div>
            <InputBase
              placeholder=""
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              // fullWidth
              inputProps={{ 'aria-label': 'search' }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
              onKeyDown={handleKeyDown}
            />
            </div>
          </div>
          <div className={classes.actionArea}>
            {!readOnly && !onlyForm && !hideAddButton &&
                <Button variant="contained" onClick={props.onAdd} className={classes.addButton} >
                  <RFIcon.Plus strokeWidth={2}/> &nbsp; {props.addButtonText}
                </Button>
            }
            { isUploadCsv &&
                <CSVReader onFileLoaded={(data, fileInfo) => {
                    // console.log(data); 
                    // console.log(fileInfo); 
                    uploadFromCsv(data)
                  }} 
                />
            }
            {/* <Tooltip title="Refresh" arrow>
              <IconButton color="inherit" component="span" onClick={props.onRefresh}>
                  <RFIcon.RefreshCw strokeWidth={2} />
              </IconButton>
            </Tooltip> */}
              {/* { !onlyForm && <Pager pager={props.pager} onPrev={props.onPrev} onNext={props.onNext} title={props.title} />} */}
            </div>
            </>}
        </Toolbar>
      </AppBar>
  );
}

function Pager(props){
  return (
        <Tooltip title={`More ${props.title}`}  arrow>
          <IconButton color="inherit" component="span" onClick={props.onNext}>
            <RFIcon.ChevronRight strokeWidth={2} />
          </IconButton>
        </Tooltip>
  )
}
